<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div *ngIf="usuario && usuario.sucesso" class="container-fluid PADRAO">
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span id="lblSubMenu"><b>{{ tituloFuncionalidade }}</b></span>
            </li>
        </ul>
        <div class="filtroDinamico"  class="col-md-12" >
            <app-filtro  (onFiltroSelected)="chamadaFiltro($event)" [parent]="this"></app-filtro>
        </div>
        
        <div class="lista-container">
            <app-extended-mat-table [columns]="columns" [dataSource]="dataSource" [parent]="this"
                [validaCorLinha]="columnRowData" class="registro-operacoes"></app-extended-mat-table>
        </div>
    </div>
</div>